import React, { useState } from "react";
import CustomTable from "../../shared/CustomTable";
import {
  LabOrderColumns,
  LaborderdummyData,
} from "../../constants/LabOrderConstansts";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../shared/CustomPagination";
import { useNavigate } from "react-router-dom";
import { EyeIcon, PrintIcon } from "../../utils/TableActionIcons";
import LabOrderFilters from "./LabOrderFilters";
import LabPagination from "../../shared/LabPagination";
import { MdOutlineTrackChanges } from "react-icons/md";
import { FaFileAlt } from "react-icons/fa";
import ViewOrderResultsModal from "./ViewOrderResultsModal";

function LabOrderTable({
  data,
  payload,
  setPayload,
  loading,
  fetchInitialData,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openResultsModal, setOpenResultsModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const onPageChange = async (newPage, newRowsPerPage) => {
    setPayload((prev) => ({
      ...prev,
      page: newPage,
      per_page: newRowsPerPage,
    }));
  };

  const actionTempelate = (rowData) => {
    return (
      <div className="flex gap-2">
        <EyeIcon
          className="cursor-pointer"
          onClick={() => {
            navigate(`/patient-profile/view-lab-orders/${rowData?._id}`, {
              state: { rowData },
            });
          }}
        />
        <MdOutlineTrackChanges
          className="cursor-pointer text-primary"
          size={16}
          onClick={() => {
            navigate(`/patient-profile/track-orders/${rowData?.order_no}`);
          }}
        />
        <PrintIcon
          title={t('View Order Results')}
          onClick={() => {
            setSelectedOrder(rowData);
            setOpenResultsModal(true);
          }}
        />
      </div>
    );
  };

  const action = {
    header: t("Actions"),
    body: actionTempelate,
    headerCellClass: "!bg-gray-200",
  };

  const labOrderColumns = LabOrderColumns(t);
  const allColumns = [action, ...labOrderColumns];

  return (
    <div>
      <LabOrderFilters
        payloadData={payload}
        setPayloadData={setPayload}
        refetch={fetchInitialData}
      />
      <CustomTable
        isLoading={loading}
        data={data?.data?.data || []}
        columns={allColumns}
      />
      <LabPagination
        currentPage={payload?.page}
        rowsPerPage={payload?.per_page}
        totalRecords={data?.data?.total_records}
        onPageChange={onPageChange}
      />
      
      <ViewOrderResultsModal
        visible={openResultsModal}
        setVisible={setOpenResultsModal}
        orderNo={selectedOrder?.order_no}
        patient={selectedOrder?.patient}
        practitioner={selectedOrder?.practitioner}
        radiology={false}
      />
    </div>
  );
}

export default LabOrderTable;
